import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Header from './ScenarioBiteHeader';
import Progress  from './ScenarioBiteProgress';
import {SCENARIO_BITE_HEADER} from "../../../models/componentModels";
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as actionTypes from '../../../actions/actionTypes';
import MainMenu from '../../dialogs/mainMenu/MainMenu';
import Resources from '../../dialogs/resources/Resources';
import Screen from '../../AppScreen';
import * as appHelper from '../../../helpers/appHelper';
import * as appConstants from '../../../constants/appConstants';
import * as enviromentHelper from '../../../helpers/environmentHelper';

class ScenarioBite extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            bite: this.props.bite,
            showHeader: true,
            biteCallbacks: {},
            fontSize: this.props.fontSize,
            height: undefined,
            updateHeight: false,
            env: enviromentHelper.getEnvironment(),
        };

        this.setBiteCallbacks = this.setBiteCallbacks.bind(this);
        this.showHeader = this.showHeader.bind(this);
        this.getClass = this.getClass.bind(this);
        this.getBiteId = this.getBiteId.bind(this);
        this.getBlurEffect = this.getBlurEffect.bind(this);
        this.setHeight = this.setHeight.bind(this);
        this.getHeight = this.getHeight.bind(this);
        this.componentWatcher = this.componentWatcher.bind(this);
    }

    componentDidMount() {
        window.addEventListener("resize", this.componentWatcher);
        //this.setHeight();

        this.setBiteCallbacks();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.fontSize !== nextProps.fontSize) {
            this.setState({fontSize: nextProps.fontSize, updateHeight: true});
        }
    }

    componentDidUpdate(){
        /*if(this.state.updateHeight){
            this.setHeight();
        }*/
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.componentWatcher);
    }

    componentWatcher(){
        let env = enviromentHelper.getEnvironment();
        this.setState({updateHeight: true});
        if((env.window.size !== this.state.env.window.size || env.window.orientation !== this.state.env.window.orientation)){
            this.setState({env: env});
        }
    }

    setBiteCallbacks() {
        this.setState({
            biteCallbacks: Object.assign({}, this.state.biteCallbacks, {
                showHeader: this.showHeader,
                getBiteId: this.getBiteId,
                setToolTip: this.setToolTip
            })
        });
    }

    showHeader(show) {
        this.setState({showHeader: show});
    }

    getBiteId() {
        return this.state.bite.bite_id;
    }

    getClass() {
        if (this.state.showHeader) {
            return "screen-wrapper";
        } else {
            return "screen-wrapper full-screen";
        }
    }

    getBlurEffect(){

        if(this.props.dialogPopup.render || this.props.assetDialog.render || this.props.screenDialog.render || this.props.displayResources !== actionTypes.STATUS_CLOSED || this.props.displayMainMenu !== actionTypes.STATUS_CLOSED){
            return 'blur on';
        }else{
            return 'blur off';
        }
    }


    setHeight(){
        this.setState({updateHeight: false});
        let windowHeight = window.innerHeight;
        let mainWrapper = document.getElementById('main-wrapper');
        //console.log(`setHeight mainWrapper`,mainWrapper.offsetHeight, `windowHeight:`, windowHeight);

        if(this.state.showHeader ) {
            let header = document.getElementById('scenarioBiteHeader');
            let progress = document.getElementById('scenarioBiteProgress');
            let newHeight = (mainWrapper.offsetHeight - header.offsetHeight - progress.offsetHeight);

            if (appHelper.isDefined(windowHeight) && windowHeight !== null && appHelper.isDefined(mainWrapper) && mainWrapper !== null && appHelper.isDefined(header) && header !== null && appHelper.isDefined(progress) && progress !== null) {
                if (windowHeight >= appConstants.DESKTOP_MAX_HEIGHT || !appHelper.isDefined(header)) {
                    newHeight = appConstants.DESKTOP_MAX_HEIGHT;
                    //console.log(`auto`, appConstants.DESKTOP_MAX_HEIGHT);
                } else if (windowHeight >= appConstants.DESKTOP_MIN_HEIGHT && windowHeight < appConstants.DESKTOP_MAX_HEIGHT) {
                    newHeight = (windowHeight - header.offsetHeight - progress.offsetHeight);
                    //console.log(`this is where i want to be ${newHeight}`);

                }

                if (appHelper.isDefined(header)) {
                    //console.log(`set new height: ${newHeight}`);
                    this.setState({height: newHeight});
                }
            }
        }
    }



    getHeight(){

        if(this.state.showHeader && appHelper.isDefined(this.state.height) && this.state.height !== appConstants.DESKTOP_MAX_HEIGHT){
            return {
                height: `${this.state.height}px`,
                minHeight: `${this.state.height}px`,
            };
        }else{
            return {};
        }
    }



    render() {
        let Dialog = this.props.dialogPopup.component;
        let AssetDialog = this.props.assetDialog.component;
        let ScreenDialog = this.props.screenDialog.component;

        let HeaderComponent = SCENARIO_BITE_HEADER.component;
        if(SCENARIO_BITE_HEADER.isAdaptive){
            if(appHelper.isDefined(SCENARIO_BITE_HEADER.adaptiveComponentSizes[this.state.env.window.size]) && appHelper.isDefined(SCENARIO_BITE_HEADER.adaptiveComponentSizes[this.state.env.window.size][this.state.env.window.orientation])){
                HeaderComponent = SCENARIO_BITE_HEADER.adaptiveComponentSizes[this.state.env.window.size][this.state.env.window.orientation];
            }else{
                HeaderComponent = SCENARIO_BITE_HEADER.component;
            }
        }
        return (
            <div className="scenario-bite">
                {
                    this.state.showHeader
                        ? <HeaderComponent bite={this.state.bite}/>
                        : null
                }
                {
                    this.state.showHeader
                        ? <Progress bite={this.state.bite}/>
                        : null
                }
                <div className="scenario-bite-content">
                    {/*<div className={`${this.getClass()} ${this.getBlurEffect()}`} id="screenWrapper" style={this.getHeight()}>*/}
                    <div className={`${this.getClass()} ${this.getBlurEffect()}`} id="screenWrapper">
                        <Screen bite={this.state.bite} biteCallbacks={this.state.biteCallbacks}/>
                    </div>

                    {this.props.screenDialog.render
                        ? <ScreenDialog />
                        : null
                    }

                    {this.props.dialogPopup.render
                        ? <Dialog />
                        : null
                    }

                    {this.props.displayResources !== actionTypes.STATUS_CLOSED
                        ? <Resources />
                        : null
                    }

                    {this.props.displayMainMenu !== actionTypes.STATUS_CLOSED
                        ? <MainMenu />
                        : null
                    }

                    {this.props.assetDialog.render
                        ? <AssetDialog />
                        : null
                    }
                </div>
            </div>
        );
    }
}

ScenarioBite.propTypes = {
    bite: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    dialogPopup: PropTypes.object.isRequired,
    displayMainMenu: PropTypes.string.isRequired,
    displayResources: PropTypes.string.isRequired,
    assetDialog: PropTypes.object.isRequired,
    screenDialog: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    fontSize: PropTypes.object.isRequired,
};

ScenarioBite.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {
        trackingData: state.trackingData,
        dialogPopup: state.dialogPopup,
        displayMainMenu: state.displayMainMenu,
        displayResources: state.displayResources,
        assetDialog: state.assetDialog,
        screenDialog: state.screenDialog,
        fontSize: state.fontSize
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions, appDataActions), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(ScenarioBite);



/** WEBPACK FOOTER **
 ** ./src/components/bites/ScenarioBite/ScenarioBite.js
 **/